export default __webpack_public_path__ + "static/media/ups.5f3ad31a.svg";